import { create } from "zustand";
import { ObjectType } from "pages/admin/objectsAndClients/objects/types";

export type ReportStoreState = {
  object?: ObjectType;
  setObject: (
    update:
      | ObjectType
      | undefined
      | ((state: ObjectType | undefined) => ObjectType | undefined)
  ) => void;
};

const useReportStore = create<ReportStoreState>((set) => ({
  object: undefined,
  setObject: (update) =>
    set((state) => ({
      object: typeof update === "function" ? update(state.object) : update,
    })),
}));

export default useReportStore;
